export default Alpine.data('taskEditGoogleMap', (livewireInstance, task, draggable) => {
    return {
        markers: [],
        disableDragging() {
            this.markers.forEach(marker => {
                marker.gmpDraggable = false;
            })
        },
        enableDragging() {
            this.markers.forEach(marker => {
                marker.gmpDraggable = true;
            })
        },
        updateLocation(event) {
            const newCenter = {
                lat: event.detail.latitude,
                lng: event.detail.longitude,
            }
            // window.map.setCenter(newCenter);
            this.markers[0].position = newCenter;
            window.map.panTo(newCenter);
        },
        bootMap() {
            const center = {
                lat: task.lat,
                lng: task.lng,
            };

            window.initMap('map', center);
            this.addMarker(center).then(() => {
                if (draggable === false) {
                    this.disableDragging();
                }
            });
        },
        async addMarker(position) {
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker")
            const draggableMarker = new AdvancedMarkerElement({
                map: window.map,
                position: position,
                gmpDraggable: true,
            });

            this.markers.push(draggableMarker);

            draggableMarker.addListener("dragend", async (event) => {
                const position = draggableMarker.position;
                const { Geocoder } = await google.maps.importLibrary("geocoding");
                const geocoder = new Geocoder();

                geocoder.geocode({ location: { lat: position.lat, lng: position.lng} }, (results, status) => {
                    if (status === "OK") {
                        if (results[0]) {
                            livewireInstance.updateTaskLocation(
                                results[0].place_id,
                                results[0].address_components,
                                results[0].formatted_address,
                                results[0].geometry.location.lat(),
                                results[0].geometry.location.lng()
                            );
                            this.$dispatch('update-autocomplete-value', results[0].formatted_address);
                        }
                    } else {
                        console.error("Geocoder failed due to: " + status);
                    }
                });

            });

        },
    }
});
